import userService from '@/services/user.service'

export default {
  // 📋 Fetch users list
  async fetchUsers({ commit, state }, payload = {}) {
    commit('SET_LOADING', true)
    commit('SET_ERROR', null)

    try {
      const filters = { ...state.filters, ...payload }
      commit('SET_FILTERS', filters)

      const res = await userService.getUsers(filters)

      commit('SET_USERS', res)
      commit('SET_PAGINATION', res)

      return res
    } catch (err) {
      commit('SET_ERROR', err.response?.data?.message || 'Failed to fetch users')
    } finally {
      commit('SET_LOADING', false)
    }
  },

  // ➕ Invite user
  async inviteUser({ commit }, data) {
    commit('SET_LOADING', true)
    commit('SET_ERROR', null)
    try {
      const user = await userService.inviteUser(data)
      commit('ADD_USER', user)
      commit('SET_MESSAGE', user.message)
      return user
    } catch (err) {
      commit('SET_ERROR', {
        message: err.message,
        errors: err.errors
      })
      throw err // 🔥 important if component needs it
    } finally {
      commit('SET_LOADING', false)
    }
  },

  
  async resendInvitation({ commit }, data) {
    commit('SET_LOADING', true)
    commit('SET_ERROR', null)
    try {
      const user = await userService.resendInvitation(data)
      //commit('ADD_USER', user)
      commit('SET_MESSAGE', user.message)
      return user
    } catch (err) {
      commit('SET_ERROR', {
        message: err.message,
        errors: err.errors
      })
      throw err // 🔥 important if component needs it
    } finally {
      commit('SET_LOADING', false)
    }
  },
  

  // 👤 Get single user
  async fetchUser({ commit }, id) {
    commit('SET_LOADING', true)

    try {
      const user = await userService.getUser(id)
      commit('SET_USER', user)
      return user
    } catch (err) {
      commit('SET_ERROR', err.response?.data?.message || 'Failed to fetch user')
    } finally {
      commit('SET_LOADING', false)
    }
  },


  // ✏️ Update
  async updateUser({ commit }, data) {
    try {
      console.log('data', data)
      const user = await userService.updateUser(data.id, data)
      commit('UPDATE_USER', user)
      commit('SET_MESSAGE', user.message)
      return user
    } catch (err) {
      console.log('err', err)
      throw err
    }
  },

  // ❌ Delete
  async deactivateUser({commit},{name, id}) {
    try {
      const res = await userService.deleteUser(id)
      commit('DELETE_USER', id)
      commit('SET_MESSAGE', `User ${name} deactivated!`)
      return res
    } catch (err) {
      console.log('err', err)
      throw err
    }
  },

  // 🔄 Toggle status
  async activateUser({commit},  {name, id}) {
    try {
      const res = await userService.activateUser(id)
      commit('SET_MESSAGE', `User ${name} reactivated!`)
      return res
    } catch (err) {
      console.log('err', err)
      throw err
    }
  },

  // 👤 Get profile
  async getProfile({ commit }) {
    try {
      const user = await userService.getProfile()
      commit('SET_USER_DATA', user.data.data)
      return user
    } catch (err) {
      commit('SET_ERROR', err.response?.data?.message || 'Failed to fetch user')
    }
  },

  // ✏️ Update
  async updateProfile({ commit }, data) {
    commit('SET_ERROR', null)
    try {
      const user = await userService.updateProfile(data)
    //  commit('UPDATE_USER', user)
      commit('SET_MESSAGE', user.message)
      return user
    } catch (err) {
      commit('SET_ERROR', err || 'Failed to update profile')
      window.scrollTo({ top: 0, behavior: 'smooth' });
      throw err
    }
  },
  async clearMessage({ commit }) {
    commit('SET_MESSAGE', null)
    commit('SET_ERROR', null)
  },

  async resetUser({ commit }) {
    commit('RESET_USER')
  },
  async resetUserProfile({ commit }) {
    commit('RESET_USER_DATA')
  },

  async changePassword({ commit }, data) {
    commit('SET_ERROR', null)
    try {
      const user = await userService.changePassword(data)
      commit('SET_MESSAGE', user.message)
      return user
    } catch (err) {
      commit('SET_ERROR', err.response?.data?.message || 'Failed to update profile')
      console.log('err', err)
      throw err
    }
  },
}